// copied from: https://git.hubteam.com/HubSpot/ui-addon-conversations-settings/blob/3c89aee1836bb1efd278f39f1bb316d4f77c6c81/static/js/components/message/tooltips/ChatFlowInboxAccessTooltip.tsx
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import UILink from 'UIComponents/link/UILink';
import { getInboxAccessUrl } from '../../../urls/inbox-urls';
import { jsx as _jsx } from "react/jsx-runtime";
const ChatFlowInboxAccessTooltip = props => {
  const href = getInboxAccessUrl(props.inboxId);
  const title = /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "routing-ui.users-and-teams.tooltips.inbox_access_jsx",
    elements: {
      UILink
    },
    options: {
      external: true,
      href
    }
  });
  return /*#__PURE__*/_jsx(UIHelpIcon, {
    title: title,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "routing-ui.users-and-teams.groups.user"
    })
  });
};
ChatFlowInboxAccessTooltip.displayName = 'ChatFlowInboxAccessTooltip';
export default ChatFlowInboxAccessTooltip;